import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
export let lastModified = undefined;
export let frontmatter = {
  "title": "Turborepo 1.1",
  "description": "Turborepo 1.1 introduces automatic migrations, turbo.json configuration, environment variable dependencies, partial Yarn v2 support, and more!",
  "date": "2022/01/31",
  "tag": "web development"
};
export let structuredData = {
  "contents": [{
    "heading": "",
    "content": "Since releasing Turborepo v1.0 in mid-December, we've seen incredible adoption:"
  }, {
    "heading": "",
    "content": "5.5k+ GitHub Stars"
  }, {
    "heading": "",
    "content": "70k+ weekly npm downloads"
  }, {
    "heading": "",
    "content": "65+ OSS contributors"
  }, {
    "heading": "",
    "content": "In production at Vercel, AWS, PayPal, Twilio, Contentful, Miro, Framer, Discord.js, Rocket.chat, Astro.build"
  }, {
    "heading": "",
    "content": "585+ members of the Turborepo Community Discord"
  }, {
    "heading": "",
    "content": "We're further improving build performance and caching with Turborepo v1.1, featuring:"
  }, {
    "heading": "",
    "content": "Automatic Migrations: Official idempotent migration scripts to assist with upgrading."
  }, {
    "heading": "",
    "content": "turbo.json Support: Turborepo configuration now lives in its own file."
  }, {
    "heading": "",
    "content": "Faster Package Manager Detection: Turborepo now respects the packageManager key in the root package.json."
  }, {
    "heading": "",
    "content": "Environment Variable Dependencies: Define how environment variables impact global and task-specific caching."
  }, {
    "heading": "",
    "content": "Partial Support for Yarn v2+: Support for yarn v2+ with nodeLinker: \"node-modules\"."
  }, {
    "heading": "",
    "content": "Update today by running npm install turbo@latest. After running turbo, you'll see instructions about how to use @turbo/codemod to run automatic migrations for v1.1."
  }, {
    "heading": "automatic-migrations",
    "content": "Turborepo now provides idempotent code transformations and automatic migration scripts (a.k.a \"codemods\") to help upgrade your Turborepo codebase when a feature is deprecated or will be deprecated in the future."
  }, {
    "heading": "automatic-migrations",
    "content": "Codemods are transformations that run on your codebase programmatically. This saves you time by applying a large number of changes to your code automatically, without having to manually go through and edit every file."
  }, {
    "heading": "usage",
    "content": "transform - the name of transform, see available transforms in the docs."
  }, {
    "heading": "usage",
    "content": "path - files or directory to transform."
  }, {
    "heading": "usage",
    "content": "--dry - Do a dry run, no code will be edited."
  }, {
    "heading": "usage",
    "content": "--print - Prints the changed output for comparison."
  }, {
    "heading": "usage",
    "content": "For more information about specific transforms, check out the new Codemods documentation."
  }, {
    "heading": "turbojson-support",
    "content": "Turborepo configuration is now defined in a turbo.json file in the root of your monorepo. This is an improvement over having a turbo key in package.json for those who want to quickly jump straight to their Turborepo configuration in their code editors."
  }, {
    "heading": "turbojson-support",
    "content": "To automatically migrate from your current configuration in package.json, check out a new branch, navigate to the root of your monorepo and run the following codemod:"
  }, {
    "heading": "turbojson-support",
    "content": "For more information on this transformation, check out the documentation."
  }, {
    "heading": "faster-package-manager-detection",
    "content": "Turborepo now supports the recently established packageManager field in package.json for faster package manager detection. Previously, turbo would check for specific files to infer this information. To automatically set this field, check out a new branch, navigate to the root of your monorepo and run:"
  }, {
    "heading": "faster-package-manager-detection",
    "content": "For more information on this transformation, check out the documentation."
  }, {
    "heading": "environment-variable-dependencies",
    "content": "When you use turbo with tools that inline environment variables at build time (e.g. Next.js or Create React App), it is important you tell turbo about it to avoid shipping a cached artifact with the wrong environment variables."
  }, {
    "heading": "environment-variable-dependencies",
    "content": "You can now control turbo's cache fingerprinting (a.k.a. hashing) behavior based on the values of both environment variables and the contents of files:"
  }, {
    "heading": "environment-variable-dependencies",
    "content": "Including environment variables in a dependsOn in your pipeline definition prefixed by a $ will impact the cache fingerprint on a per-task or per-package-task basis."
  }, {
    "heading": "environment-variable-dependencies",
    "content": "Including environment variables in globalDependencies list prefixed by a $ will impact the cache fingerprint of all tasks."
  }, {
    "heading": "environment-variable-dependencies",
    "content": "Including files or globs of files in globalDependencies will impact the cache fingerprint of all tasks."
  }, {
    "heading": "environment-variable-dependencies",
    "content": "Note: In most monorepos, you don't often use environment variables in shared packages, but mostly in applications. Thus, to get higher cache hit rates, you should only include environment variables in the app-specific tasks where they are used/inlined."
  }, {
    "heading": "environment-variable-dependencies",
    "content": "For more information, read the caching and hashing documentation."
  }, {
    "heading": "partial-yarn-v2v3-support",
    "content": "In addition to Yarn v1, npm, and pnpm package managers, Turborepo now supports Yarn v2+ with nodeLinker: \"node-modules\" set in .yarnrc.yml. This key tells Yarn v2+ to mimic Yarn v1's node_modules installation behavior. Yarn v2+ Plug'n'Play (a.k.a. \"PnP\") is not currently supported."
  }, {
    "heading": "whats-next",
    "content": "Since our launch, Turborepo has focused on seamless incremental adoption/migration and speeding up CI/CD. We are committed to both of those values, but now we'll also be focusing on improving Turborepo's day-to-day ergonomics for local development and observability. We're really excited about this next chapter and will be sharing more details soon."
  }, {
    "heading": "were-hiring",
    "content": "The Turborepo team at Vercel is hiring! We're specifically looking for full time Senior Full Stack Software Engineers and Senior DevOps/Infrastructure Engineers to help us make Turborepo even better."
  }],
  "headings": [{
    "id": "automatic-migrations",
    "content": "Automatic Migrations"
  }, {
    "id": "usage",
    "content": "Usage"
  }, {
    "id": "turbojson-support",
    "content": "turbo.json Support"
  }, {
    "id": "faster-package-manager-detection",
    "content": "Faster Package Manager Detection"
  }, {
    "id": "environment-variable-dependencies",
    "content": "Environment Variable Dependencies"
  }, {
    "id": "partial-yarn-v2v3-support",
    "content": "Partial Yarn v2/v3 support"
  }, {
    "id": "whats-next",
    "content": "What's next?"
  }, {
    "id": "were-hiring",
    "content": "We're hiring!"
  }]
};
import __img0 from "./../../public/images/blog/turbo-1-1-0/turborepo-weekly-npm-downloads.png";
import {Authors} from '#components/authors';
export const toc = [{
  depth: 2,
  url: "#automatic-migrations",
  title: _jsx(_Fragment, {
    children: "Automatic Migrations"
  })
}, {
  depth: 3,
  url: "#usage",
  title: _jsx(_Fragment, {
    children: "Usage"
  })
}, {
  depth: 2,
  url: "#turbojson-support",
  title: _jsxs(_Fragment, {
    children: [_jsx("code", {
      children: "turbo.json"
    }), " Support"]
  })
}, {
  depth: 2,
  url: "#faster-package-manager-detection",
  title: _jsx(_Fragment, {
    children: "Faster Package Manager Detection"
  })
}, {
  depth: 2,
  url: "#environment-variable-dependencies",
  title: _jsx(_Fragment, {
    children: "Environment Variable Dependencies"
  })
}, {
  depth: 2,
  url: "#partial-yarn-v2v3-support",
  title: _jsx(_Fragment, {
    children: "Partial Yarn v2/v3 support"
  })
}, {
  depth: 2,
  url: "#whats-next",
  title: _jsx(_Fragment, {
    children: "What's next?"
  })
}, {
  depth: 2,
  url: "#were-hiring",
  title: _jsx(_Fragment, {
    children: "We're hiring!"
  })
}];
function _createMdxContent(props) {
  const _components = {
    a: "a",
    code: "code",
    em: "em",
    h2: "h2",
    h3: "h3",
    img: "img",
    li: "li",
    p: "p",
    pre: "pre",
    span: "span",
    strong: "strong",
    ul: "ul",
    ...props.components
  };
  return _jsxs(_Fragment, {
    children: [_jsx("h1", {
      className: "text-center",
      children: "Turborepo 1.1"
    }), "\n", "\n", _jsx(Authors, {
      authors: ['jaredpalmer', 'becca__z', 'gaspargarcia', 'gregsoltis']
    }), "\n", _jsx(_components.p, {
      children: "Since releasing Turborepo v1.0 in mid-December, we've seen incredible adoption:"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsx(_components.li, {
        children: "5.5k+ GitHub Stars"
      }), "\n", _jsx(_components.li, {
        children: "70k+ weekly npm downloads"
      }), "\n", _jsx(_components.li, {
        children: "65+ OSS contributors"
      }), "\n", _jsxs(_components.li, {
        children: ["In production at ", _jsx(_components.a, {
          href: "https://github.com/vercel/next.js",
          children: "Vercel"
        }), ", ", _jsx(_components.a, {
          href: "https://github.com/aws-amplify/amplify-ui",
          children: "AWS"
        }), ", ", _jsx(_components.a, {
          href: "https://x.com/jaredpalmer/status/1485617973477978121",
          children: "PayPal"
        }), ", ", _jsx(_components.a, {
          href: "https://github.com/twilio-labs/function-templates",
          children: "Twilio"
        }), ", ", _jsx(_components.a, {
          href: "https://github.com/contentful/forma-36",
          children: "Contentful"
        }), ", ", _jsx(_components.a, {
          href: "https://github.com/miroapp/app-examples",
          children: "Miro"
        }), ", ", _jsx(_components.a, {
          href: "https://github.com/framer/motion",
          children: "Framer"
        }), ", ", _jsx(_components.a, {
          href: "https://github.com/discordjs/discord.js",
          children: "Discord.js"
        }), ", ", _jsx(_components.a, {
          href: "https://github.com/RocketChat/fuselage",
          children: "Rocket.chat"
        }), ", ", _jsx(_components.a, {
          href: "https://github.com/withastro/astro",
          children: "Astro.build"
        })]
      }), "\n", _jsxs(_components.li, {
        children: ["585+ members of the ", _jsx(_components.a, {
          href: "https://turborepo.com/discord",
          children: "Turborepo Community Discord"
        })]
      }), "\n"]
    }), "\n", _jsx(_components.p, {
      children: _jsx(_components.img, {
        alt: "Weekly npm downloads of turbo",
        placeholder: "blur",
        src: __img0
      })
    }), "\n", _jsx(_components.p, {
      children: "We're further improving build performance and caching with Turborepo v1.1, featuring:"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: [_jsx(_components.a, {
          href: "#automatic-migrations",
          children: _jsx(_components.strong, {
            children: "Automatic Migrations:"
          })
        }), " Official idempotent migration scripts to assist with upgrading."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.a, {
          href: "#turbojson-support",
          children: _jsxs(_components.strong, {
            children: [_jsx(_components.code, {
              children: "turbo.json"
            }), " Support:"]
          })
        }), " Turborepo configuration now lives in its own file."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.a, {
          href: "#faster-package-manager-detection",
          children: _jsx(_components.strong, {
            children: "Faster Package Manager Detection:"
          })
        }), " Turborepo now respects the ", _jsx(_components.code, {
          children: "packageManager"
        }), " key in the root ", _jsx(_components.code, {
          children: "package.json"
        }), "."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.a, {
          href: "#environment-variable-dependencies",
          children: _jsx(_components.strong, {
            children: "Environment Variable Dependencies:"
          })
        }), " Define how environment variables impact global and task-specific caching."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.a, {
          href: "#partial-yarn-v2v3-support",
          children: _jsx(_components.strong, {
            children: "Partial Support for Yarn v2+:"
          })
        }), " Support for yarn v2+ with ", _jsx(_components.code, {
          children: "nodeLinker: \"node-modules\""
        }), "."]
      }), "\n"]
    }), "\n", _jsxs(_components.p, {
      children: ["Update today by running ", _jsx(_components.code, {
        children: "npm install turbo@latest"
      }), ". After running ", _jsx(_components.code, {
        children: "turbo"
      }), ", you'll see instructions about how to use ", _jsx(_components.code, {
        children: "@turbo/codemod"
      }), " to run automatic migrations for ", _jsx(_components.code, {
        children: "v1.1"
      }), "."]
    }), "\n", _jsx(_components.h2, {
      id: "automatic-migrations",
      children: "Automatic Migrations"
    }), "\n", _jsx(_components.p, {
      children: "Turborepo now provides idempotent code transformations and automatic migration scripts (a.k.a \"codemods\") to help upgrade your Turborepo codebase when a feature is deprecated or will be deprecated in the future."
    }), "\n", _jsx(_components.p, {
      children: "Codemods are transformations that run on your codebase programmatically. This saves you time by applying a large number of changes to your code automatically, without having to manually go through and edit every file."
    }), "\n", _jsx(_components.h3, {
      id: "usage",
      children: "Usage"
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "Terminal",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
        children: _jsx(_components.code, {
          children: _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "npx"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " @turbo/codemod"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: " <"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: "transfor"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "m"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: ">"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: " <"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: "pat"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "h"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: ">"
            })]
          })
        })
      })
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: [_jsx(_components.code, {
          children: "transform"
        }), " - the name of transform, ", _jsx(_components.a, {
          href: "/docs/reference/turbo-codemod#turborepo-1x",
          children: "see available transforms in the docs"
        }), "."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.code, {
          children: "path"
        }), " - files or directory to transform."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.code, {
          children: "--dry"
        }), " - Do a dry run, no code will be edited."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.code, {
          children: "--print"
        }), " - Prints the changed output for comparison."]
      }), "\n"]
    }), "\n", _jsxs(_components.p, {
      children: ["For more information about specific transforms, check out the ", _jsx(_components.a, {
        href: "/docs/reference/turbo-codemod#turborepo-1x",
        children: "new Codemods documentation"
      }), "."]
    }), "\n", _jsxs(_components.h2, {
      id: "turbojson-support",
      children: [_jsx(_components.code, {
        children: "turbo.json"
      }), " Support"]
    }), "\n", _jsxs(_components.p, {
      children: ["Turborepo configuration is now defined in a ", _jsx(_components.code, {
        children: "turbo.json"
      }), " file in the root of your monorepo. This is an improvement over having a ", _jsx(_components.code, {
        children: "turbo"
      }), " key in ", _jsx(_components.code, {
        children: "package.json"
      }), " for those who want to quickly jump straight to their Turborepo configuration in their code editors."]
    }), "\n", _jsxs(_components.p, {
      children: ["To automatically migrate from your current configuration in ", _jsx(_components.code, {
        children: "package.json"
      }), ", check out a new branch, navigate to the root of your monorepo and run the following codemod:"]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "Terminal",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
        children: _jsx(_components.code, {
          children: _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "npx"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " @turbo/codemod"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " create-turbo-config"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " ."
            })]
          })
        })
      })
    }), "\n", _jsxs(_components.p, {
      children: ["For more information on this transformation, ", _jsx(_components.a, {
        href: "/docs/reference/turbo-codemod#create-turbo-config",
        children: "check out the documentation"
      }), "."]
    }), "\n", _jsx(_components.h2, {
      id: "faster-package-manager-detection",
      children: "Faster Package Manager Detection"
    }), "\n", _jsxs(_components.p, {
      children: ["Turborepo now supports the recently established ", _jsx(_components.code, {
        children: "packageManager"
      }), " field in ", _jsx(_components.code, {
        children: "package.json"
      }), " for faster package manager detection. Previously, ", _jsx(_components.code, {
        children: "turbo"
      }), " would check for specific files to infer this information. To automatically set this field, check out a new branch, navigate to the root of your monorepo and run:"]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "Terminal",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
        children: _jsx(_components.code, {
          children: _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "npx"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " @turbo/codemod"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " add-package-manager"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " ."
            })]
          })
        })
      })
    }), "\n", _jsxs(_components.p, {
      children: ["For more information on this transformation, ", _jsx(_components.a, {
        href: "/docs/reference/turbo-codemod#add-package-manager",
        children: "check out the documentation"
      }), "."]
    }), "\n", _jsx(_components.h2, {
      id: "environment-variable-dependencies",
      children: "Environment Variable Dependencies"
    }), "\n", _jsxs(_components.p, {
      children: ["When you use ", _jsx(_components.code, {
        children: "turbo"
      }), " with tools that inline environment variables at build time (e.g. Next.js or Create React App), it is important you tell ", _jsx(_components.code, {
        children: "turbo"
      }), " about it to avoid shipping a cached artifact with the wrong environment variables."]
    }), "\n", _jsxs(_components.p, {
      children: ["You can now control ", _jsx(_components.code, {
        children: "turbo"
      }), "'s ", _jsx(_components.a, {
        href: "/docs/crafting-your-repository/caching#task-inputs",
        children: "cache fingerprinting (a.k.a. hashing)"
      }), " behavior based on the values of both environment variables and the contents of files:"]
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: ["Including environment variables in a ", _jsx(_components.code, {
          children: "dependsOn"
        }), " in your ", _jsx(_components.code, {
          children: "pipeline"
        }), " definition prefixed by a ", _jsx(_components.code, {
          children: "$"
        }), " will impact the cache fingerprint on a per-task or per-package-task basis."]
      }), "\n", _jsxs(_components.li, {
        children: ["Including environment variables in ", _jsx(_components.code, {
          children: "globalDependencies"
        }), " list prefixed by a ", _jsx(_components.code, {
          children: "$"
        }), " will impact the cache fingerprint of ", _jsx(_components.em, {
          children: "all"
        }), " tasks."]
      }), "\n", _jsxs(_components.li, {
        children: ["Including files or globs of files in ", _jsx(_components.code, {
          children: "globalDependencies"
        }), " will impact the cache fingerprint of ", _jsx(_components.em, {
          children: "all"
        }), " tasks."]
      }), "\n"]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "./turbo.json",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "{"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"pipeline\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "    \"build\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "      \"dependsOn\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "        \"^build\""
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-comment)",
                "--shiki-dark": "var(--shiki-token-comment)"
              },
              children: "        // env vars will impact hashes of all \"build\" tasks"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "        \"$SOME_ENV_VAR\""
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "      }"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "      \"outputs\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " ["
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "\"dist/**\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "]"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "    }"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "    \"web#build\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " { "
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-comment)",
                "--shiki-dark": "var(--shiki-token-comment)"
              },
              children: "// override settings for the \"build\" task for the \"web\" app"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "      \"dependsOn\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " ["
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "        \"^build\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-comment)",
                "--shiki-dark": "var(--shiki-token-comment)"
              },
              children: "          // env vars that will impact the hash of \"build\" task for only \"web\" app"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "          \"$STRIPE_SECRET_KEY\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "          \"$NEXT_PUBLIC_STRIPE_PUBLIC_KEY\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "          \"$NEXT_PUBLIC_ANALYTICS_ID\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "      ]"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "      \"outputs\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " ["
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "\".next/**\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: " \"!.next/cache/**\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "]"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "    }"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "    \"docs#build\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " { "
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-comment)",
                "--shiki-dark": "var(--shiki-token-comment)"
              },
              children: "// override settings for the \"build\" task for the \"docs\" app"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "      \"dependsOn\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " ["
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "        \"^build\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-comment)",
                "--shiki-dark": "var(--shiki-token-comment)"
              },
              children: "          // env vars that will impact the hash of \"build\" task for only \"web\" app"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "          \"$STRIPE_SECRET_KEY\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "          \"$NEXT_PUBLIC_STRIPE_PUBLIC_KEY\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "          \"$NEXT_PUBLIC_ANALYTICS_ID\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "      ]"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "      \"outputs\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " ["
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "\".next/**\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: " \"!.next/cache/**\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "]"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "    }"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "  }"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"globalDependencies\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " ["
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "    \"$GITHUB_TOKEN\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-comment)",
                "--shiki-dark": "var(--shiki-token-comment)"
              },
              children: "// env var that will impact the hashes of all tasks,"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "    \"tsconfig.json\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-comment)",
                "--shiki-dark": "var(--shiki-token-comment)"
              },
              children: " // file contents will impact the hashes of all tasks,"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "    \".env.*\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-comment)",
                "--shiki-dark": "var(--shiki-token-comment)"
              },
              children: " // glob file contents will impact the hashes of all tasks,"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "  ]"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "}"
            })
          })]
        })
      })
    }), "\n", _jsx(_components.p, {
      children: "Note: In most monorepos, you don't often use environment variables in shared packages, but mostly in applications. Thus, to get higher cache hit rates, you should only include environment variables in the app-specific tasks where they are used/inlined."
    }), "\n", _jsxs(_components.p, {
      children: ["For more information, read the ", _jsx(_components.a, {
        href: "/docs/crafting-your-repository/caching#task-inputs",
        children: "caching and hashing documentation"
      }), "."]
    }), "\n", _jsx(_components.h2, {
      id: "partial-yarn-v2v3-support",
      children: "Partial Yarn v2/v3 support"
    }), "\n", _jsxs(_components.p, {
      children: ["In addition to Yarn v1, npm, and pnpm package managers, Turborepo now supports Yarn v2+ with ", _jsxs(_components.a, {
        href: "https://yarnpkg.com/configuration/yarnrc#nodeLinker",
        children: [_jsx(_components.code, {
          children: "nodeLinker: \"node-modules\""
        }), " set in ", _jsx(_components.code, {
          children: ".yarnrc.yml"
        })]
      }), ". This key tells Yarn v2+ to mimic Yarn v1's ", _jsx(_components.code, {
        children: "node_modules"
      }), " installation behavior. Yarn v2+ Plug'n'Play (a.k.a. \"PnP\") is not currently supported."]
    }), "\n", _jsx(_components.h2, {
      id: "whats-next",
      children: "What's next?"
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.a, {
        href: "/blog/joining-vercel",
        children: "Since our launch"
      }), ", Turborepo has focused on seamless incremental adoption/migration and speeding up CI/CD. We are committed to both of those values, but now we'll also be focusing on improving Turborepo's day-to-day ergonomics for local development and observability. We're really excited about this next chapter and will be sharing more details soon."]
    }), "\n", _jsx(_components.h2, {
      id: "were-hiring",
      children: "We're hiring!"
    }), "\n", _jsxs(_components.p, {
      children: ["The Turborepo team at ", _jsx(_components.a, {
        href: "https://vercel.com/",
        children: "Vercel"
      }), " is hiring! We're specifically looking for full time ", _jsx(_components.a, {
        href: "https://vercel.com/careers",
        children: "Senior Full Stack Software Engineers"
      }), " and ", _jsx(_components.a, {
        href: "https://vercel.com/careers",
        children: "Senior DevOps/Infrastructure Engineers"
      }), " to help us make Turborepo even better."]
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = props.components || ({});
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
